import React from 'react';
import * as FPT from '../utility/fpt';
import { BodyText, Divider } from '@paypalcorp/pp-react';
import ReengagementTile from './ReengagementTile';

export default function ConfirmationMyAccount(props) {
  const { engamentText, link, message } = props;

  const handleMyAccount = () => {
    FPT.trackLinkClick('myAccount');
    window.location.href = '/myaccount';
  };

  return (
    <>
      <Divider
        secondary
        style={{
          maxWidth: '400px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      />
      <BodyText
        style={{
          textAlign: 'center',
          marginTop: '5%',
          marginBottom: '5%',
        }}
      >
        {engamentText}
      </BodyText>
      <ReengagementTile
        type="activity"
        description={message}
        descriptionLink={link}
        clickEvent={handleMyAccount}
      />
    </>
  );
}
